import { QUERY_KEYS } from '../../../../type';
import { useQuery } from '@umijs/max';
import { useMemo } from 'react';
import * as API from '../../services';
import { useStore } from '../../store';

export const findTag = (
  code?: string,
  options: SelectOptions = [],
): SelectOptions[number] | null => {
  if (!code) return null;
  for (const option of options) {
    if (option.value === code) {
      return option;
    }
    if (option.options) {
      const result = findTag(code, option.options);
      if (result) return result;
    }
  }
  return null;
};

type SelectOptions = {
  label: string | React.ReactNode;
  value?: string;
  title?: string;
  options?: SelectOptions;
  type?: 'text' | 'table' | 'seal' | 'hand_writing';
  parent_value?: string;
  parent_label?: string;
}[];

const useExtractTags = () => {
  const template_code = useStore((s) => s.template_code);

  const {
    data: extractTags,
    isLoading: loading,
    isSuccess,
  } = useQuery({
    queryKey: [
      QUERY_KEYS.WORKFLOW_CONFIG,
      API.getExtractionTags.queryKey,
      template_code,
    ],
    queryFn: async () => API.getExtractionTags(template_code),
    // enabled: Boolean(template_code),
    refetchOnWindowFocus: true,
    select(data) {
      return data.data;
    },
  });

  const selectOptions: SelectOptions = useMemo(
    () => [
      {
        label: <span>抽取点</span>,
        title: '抽取点',
        options: extractTags?.text_tags.map((tag, idx) => {
          return {
            label: tag.tag_name,
            value: tag.tag_code,
            type: 'text' as const,
          };
        }),
      },
      ...(extractTags?.table_tags?.map((table) => {
        return {
          label: table.table_name,
          title: table.table_name,
          options: table.tags.map((tag) => {
            return {
              label: tag.tag_name,
              value: tag.tag_code,
              parent_value: table.table_code,
              parent_label: table.table_name,
              type: 'table' as const,
            };
          }),
        };
      }) || []),
      ...(extractTags?.seal_tags?.map((tag) => {
        return {
          label: tag.tag_name,
          value: tag.tag_code,
          type: 'seal' as const,
        };
      }) || []),
      ...(extractTags?.hand_writing_tags?.map((tag) => {
        return {
          label: tag.tag_name,
          value: tag.tag_code,
          type: 'hand_writing' as const,
        };
      }) || []),
    ],
    [extractTags],
  );

  return {
    loading,
    selectOptions,
    extractTags,
    findTag,
    isSuccess,
  };
};

export default useExtractTags;
